import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import {
    ITransitionItem,
    coverTransition,
    cutTransition,
    emptyTransition,
    fadeTransition,
    flashTransition,
    flipTransition,
    galleryTransition,
    prismTransition,
    pullTransition,
    pushTransition,
    switchTransition,
    warpTransition,
} from '@framework/workbench/common/components/selectable-panel/transition-card/config';

export const config = {
    id: ActionType.TRANSITION_CHANGE,
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        shrinkable: 'steps',
        style: {
            width: 'auto',
        },
        shrinkSteps: [312, 384, 456, 528, 602],
        widthRange: [240, 704],
        preventHighlight: true,
    },
];

export const TransitionList: ITransitionItem[] = [
    emptyTransition,
    fadeTransition,
    pushTransition,
    switchTransition,
    cutTransition,
    pullTransition,
    coverTransition,
    warpTransition,
    flipTransition,
    galleryTransition,
    prismTransition,
    flashTransition,
];
